// @ts-nocheck
// ====== Vista calendario scadenze ======
// Toggle "Lista | Calendario" sopra la vista Scadenze. La modalità calendario
// renderizza una griglia mensile (lun-dom) con pillole cliccabili per ogni
// scadenza del giorno. Il click sulla pillola apre la scheda cliente sulla tab
// Scadenze.

const DOW = ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'];
const MONTHS = [
  'Gennaio',
  'Febbraio',
  'Marzo',
  'Aprile',
  'Maggio',
  'Giugno',
  'Luglio',
  'Agosto',
  'Settembre',
  'Ottobre',
  'Novembre',
  'Dicembre'
];

let _calCursor = startOfMonth(new Date());
let _scadMode = 'list';

function startOfMonth(d) {
  const x = new Date(d);
  x.setDate(1);
  x.setHours(0, 0, 0, 0);
  return x;
}

function pad(n) {
  return String(n).padStart(2, '0');
}

function ymd(d) {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

function collectAllScadenze() {
  const out = [];
  (state?.clients || []).forEach((c) => {
    (c.scadenze || []).forEach((s) => {
      if (!s.data) return;
      out.push({
        cliente: c.nome,
        cpl: c.cpl || '',
        titolo: s.titolo || '(senza titolo)',
        tipo: s.tipo || '',
        data: s.data,
        completata: !!s.completata,
        kind: 'scadenza'
      });
    });
    if (c.contratto?.fine) {
      out.push({
        cliente: c.nome,
        cpl: c.cpl || '',
        titolo: 'Fine contratto',
        tipo: 'Contratto',
        data: c.contratto.fine,
        completata: false,
        kind: 'contratto',
        contrattoNumero: c.contratto.numero || ''
      });
    }
  });
  return out;
}

function pillClass(item) {
  if (item.completata) return 'cal-pill done';
  const g = typeof daysUntil === 'function' ? daysUntil(item.data) : null;
  if (g == null) return 'cal-pill';
  if (g < 0) return 'cal-pill danger';
  if (g <= 30) return 'cal-pill warn';
  return 'cal-pill ok';
}

function renderScadenzeCalendar() {
  const grid = document.getElementById('scadCalendar');
  const label = document.getElementById('calMonthLabel');
  const countEl = document.getElementById('calCount');
  if (!grid) return;
  const cur = _calCursor;
  const year = cur.getFullYear();
  const month = cur.getMonth();
  if (label) label.textContent = `${MONTHS[month]} ${year}`;

  // Calcola la prima cella della griglia: lunedì della settimana che contiene il 1° del mese
  const first = new Date(year, month, 1);
  const dowFirst = (first.getDay() + 6) % 7; // 0=Lun
  const gridStart = new Date(year, month, 1 - dowFirst);

  // Carica scadenze del mese visibile e dei bordi (42 giorni)
  const all = collectAllScadenze();
  const byDay = new Map();
  for (let i = 0; i < 42; i++) {
    const d = new Date(gridStart);
    d.setDate(gridStart.getDate() + i);
    byDay.set(ymd(d), []);
  }
  let monthCount = 0;
  all.forEach((it) => {
    const k = (it.data || '').slice(0, 10);
    if (byDay.has(k)) {
      byDay.get(k).push(it);
      const d = new Date(k);
      if (d.getMonth() === month && d.getFullYear() === year) monthCount++;
    }
  });
  if (countEl)
    countEl.textContent = monthCount
      ? `${monthCount} scadenz${monthCount === 1 ? 'a' : 'e'} questo mese`
      : 'Nessuna scadenza';

  const today = ymd(new Date());

  let html = '<div class="cal-head">';
  DOW.forEach((d) => (html += `<div class="cal-dow">${d}</div>`));
  html += '</div><div class="cal-cells">';
  for (let i = 0; i < 42; i++) {
    const d = new Date(gridStart);
    d.setDate(gridStart.getDate() + i);
    const k = ymd(d);
    const inMonth = d.getMonth() === month;
    const isToday = k === today;
    const items = byDay.get(k) || [];
    html += `<div class="cal-cell ${inMonth ? '' : 'out'} ${isToday ? 'today' : ''}" data-d="${k}">
      <div class="cal-day-num">${d.getDate()}</div>
      <div class="cal-pills">${items
        .slice(0, 4)
        .map(
          (it) =>
            `<button type="button" class="${pillClass(it)}" data-cliente="${escapeHtml(it.cliente)}" data-tab="scadenze" title="${escapeHtml(it.cliente)} — ${escapeHtml(it.titolo)}${it.tipo ? ' (' + it.tipo + ')' : ''}">${escapeHtml(it.cliente)} · ${escapeHtml(it.titolo)}</button>`
        )
        .join(
          ''
        )}${items.length > 4 ? `<span class="cal-more">+${items.length - 4}</span>` : ''}</div>
    </div>`;
  }
  html += '</div>';
  grid.innerHTML = html;

  // Wiring pillole -> apre modal cliente sulla tab scadenze
  grid.querySelectorAll('.cal-pill').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const cli = btn.dataset.cliente;
      if (!cli) return;
      if (typeof openModal === 'function') openModal(cli, 'scadenze');
    });
  });
}

function setScadMode(mode) {
  _scadMode = mode === 'calendar' ? 'calendar' : 'list';
  const listCard = document.getElementById('scadenzeListCard');
  const calCard = document.getElementById('scadenzeCalendarCard');
  if (listCard) listCard.classList.toggle('hidden', _scadMode !== 'list');
  if (calCard) calCard.classList.toggle('hidden', _scadMode !== 'calendar');
  document.getElementById('scadModeList')?.classList.toggle('active', _scadMode === 'list');
  document.getElementById('scadModeCal')?.classList.toggle('active', _scadMode === 'calendar');
  document.getElementById('scadModeList')?.setAttribute('aria-pressed', _scadMode === 'list');
  document.getElementById('scadModeCal')?.setAttribute('aria-pressed', _scadMode === 'calendar');
  if (_scadMode === 'calendar') renderScadenzeCalendar();
}

// Hook: ogni volta che renderScadenze viene chiamato, refreshare anche il calendario
const _origRenderScadenze = globalThis.renderScadenze;
if (typeof _origRenderScadenze === 'function') {
  globalThis.renderScadenze = function () {
    _origRenderScadenze.apply(this, arguments);
    if (_scadMode === 'calendar') renderScadenzeCalendar();
  };
}

// Wiring idempotente dei controlli calendario (la vista "scadenze" è lazy).
let _scadCalWired = false;
function wireScadenzeCalendarControls() {
  if (_scadCalWired) return;
  if (!document.getElementById('scadModeList')) return; // vista non ancora montata
  document.getElementById('scadModeList')?.addEventListener('click', () => setScadMode('list'));
  document.getElementById('scadModeCal')?.addEventListener('click', () => setScadMode('calendar'));
  document.getElementById('calPrevMonth')?.addEventListener('click', () => {
    _calCursor = new Date(_calCursor.getFullYear(), _calCursor.getMonth() - 1, 1);
    renderScadenzeCalendar();
  });
  document.getElementById('calNextMonth')?.addEventListener('click', () => {
    _calCursor = new Date(_calCursor.getFullYear(), _calCursor.getMonth() + 1, 1);
    renderScadenzeCalendar();
  });
  document.getElementById('calToday')?.addEventListener('click', () => {
    _calCursor = startOfMonth(new Date());
    renderScadenzeCalendar();
  });
  _scadCalWired = true;
}
document.addEventListener('DOMContentLoaded', wireScadenzeCalendarControls);
globalThis.bus?.on?.('view:lazy-loaded', (p) => {
  if (p && p.viewId === 'scadenze') wireScadenzeCalendarControls();
});

Object.assign(globalThis, { renderScadenzeCalendar, setScadMode });
export {};
